"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Evexia API
 * OpenAPI Spec for Evexia APIs
 *
 * The version of the OpenAPI document: 1.0
 * Contact: ch_engineering@calm.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.CircleConsentTypes = void 0;
exports.CircleConsentTypes = {
    HealthcarePortability: 'healthcare_portability',
    Parental: 'parental',
    Gina: 'gina',
    Chdpp: 'chdpp',
    International: 'international',
    AuInternational: 'au_international',
    CnInternational: 'cn_international',
    EuInternational: 'eu_international',
    InInternational: 'in_international',
    UkInternational: 'uk_international',
};
//# sourceMappingURL=circle-consent-types.js.map